import { Box } from '@material-ui/core';
import { StandardDialog, Button } from '@roc/ui';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { usePayoffRequestStore } from '@roc/feature-loans';
import { useBaseStore } from '@roc/feature-app-core';
import { CurrencyField } from '@roc/ui';
import { Typography } from '@material-ui/core';


interface IApprovePayoffDialogProps {
  loanId: number;
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(theme => ({
  button: {
    marginRight: '8px'
  },
  typography: {
    marginBottom: '10px'
  }
}));

export const ApprovePayoffDialog = observer(({ loanId, open, onClose }: IApprovePayoffDialogProps) => {
  const classes = useStyles();
  const { payoffRequestStore } = usePayoffRequestStore();
  const [servicerPayoffAmount, setServicerPayoffAmount] = useState<number>()
  const disabled = !servicerPayoffAmount || servicerPayoffAmount == 0
  const { globalStore } = useBaseStore();
  const currentPayoff = payoffRequestStore.selectedPayoff;

  const onSubmit = async () => {
    if (servicerPayoffAmount) {
      payoffRequestStore.approvePayoff(loanId, currentPayoff?.loanPayoffDataId, servicerPayoffAmount);
      onClose();
    } else {
      globalStore.notificationStore.showErrorNotification({
        message: 'Please enter the payoff amount',
      });
    }

  }

  const getContent = () => {
    return (
      <Box display="flex" justifyContent={"center"} flexDirection="column" height="100%" width="100%">
        <Typography className={classes.typography}>Please input the servicer payoff amount in order to proceed with the payoff approval</Typography>
        <CurrencyField
          variant={'outlined'}
          testId={'servicerPayoffAmountId'}
          value={servicerPayoffAmount}
          fullWidth
          onChange={(_, val) => {
            const num = Number(val)
            setServicerPayoffAmount(val === '' ? undefined : num)
          }}
        />
      </Box>
    )
  }

  return (
    <StandardDialog
      open={open}
      title={'Approve Payoff'}
      maxWidth="sm"
      handleClose={onClose}
      dialogContent={
        getContent()
      }
      dialogActions={(
        <>
          <Box mr={2}>
            <Button
              className={classes.button}
              variant="outlined"
              color="primary"
              onClick={onClose}
              testId="close"
            >
              CLOSE
            </Button>
            <Button
              className={classes.button}
              color="primary"
              variant="contained"
              onClick={onSubmit}
              testId="close"
              disabled={disabled}
            >
              SUBMIT
            </Button>
          </Box>
        </>
      )}
    />
  );
});